export default __webpack_public_path__ + "static/meshmate-tanuj-agarwal-90d40e467302ee7cca1089c445590f0e.webp";